<template>
  <main
    ref="ContentSlideWrapper"
    class="absolute inset-0"
  >
    <Transition name="fade">
      <Header
        v-show="$route.meta.header"
        :category="category"
        :content="content"
        class="absolute top-0 z-10"
      />
    </Transition>

    <Transition :name="transition">
      <RouterView
        :key="media.slug"
        :media="media"
        :category="category"
        :pager="pager"
      />
    </Transition>

    <Transition name="fade">
      <FpNavDotsSlide
        v-show="$route.name === 'content' && pager.contentLength > 1"
        :slides="content"
        class="absolute bottom-4 md:bottom-10 pin-c-x"
      />
    </Transition>

    <Transition name="fade">
      <ChevronBtn
        v-show="$route.name === 'content' && pager.contentLength > 1"
        :direction="'next'"
        :title="pager.next.title"
        class="fixed right-2 md:right-3 pin-c-y"
        @click.native="pushRoute(pager.next.slug)"
      />
    </Transition>

    <Transition name="fade">
      <ChevronBtn
        v-show="$route.name === 'content' && pager.contentLength > 1"
        :direction="'Prev'"
        :title="pager.prev.title"
        class="fixed left-2 md:left-3 pin-c-y"
        @click.native="pushRoute(pager.prev.slug)"
      />
    </Transition>
  </main>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import FpNavDotsSlide from '@/components/FpNavDotsSlide.vue'
import ChevronBtn from '@/components/buttons/ChevronBtn.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'Contents',

  components: {
    Header,
    FpNavDotsSlide,
    ChevronBtn
  },

  data: () => ({
    transition: '',
    throttle: false
  }),

  computed: {
    ...mapState([ 'touch', 'mobile', 'isMedia', 'isNavigation' ]),
    ...mapGetters([ 'getMediaBySlug', 'getCategoryBySlug' ]),

    media() {
      return this.getMediaBySlug(this.$route.params.media_id)
    },
    category() {
      return this.getCategoryBySlug(this.$route.params.category_id)
    },
    content() {
      return this.category.children
    },
    pager() {
      const content = this.content

      const contentLength = content.length

      const contentSlugs = content.map(({ slug }) => slug)

      const currentContent = this.$route.params.media_id

      const currentIndex = contentSlugs.indexOf(currentContent)

      const prev = currentIndex > 0 ? content[currentIndex - 1] : content[contentLength - 1]

      const next = currentIndex < contentLength - 1 ? content[currentIndex + 1] : content[0]

      return { prev, next, currentIndex, currentContent, contentSlugs, contentLength }
    },
    listenersTarget() {
      return this.$refs.ContentSlideWrapper
    }
  },

  beforeRouteUpdate(to, from, next) {
    const toIndex = this.pager.contentSlugs.indexOf(to.params.media_id)

    this.transition = toIndex > this.pager.currentIndex ? 'slide-view-left' : 'slide-view-right'

    next()
  },

  mounted() {
    this.addListeners()
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.handleArrowKeys)
  },

  methods: {
    pushRoute(path) {
      if (!this.throttle && !this.isMedia && !this.isNavigation) {
        this.throttle = true
        this.$router.push({
          name: 'content',
          params: {
            category_id: this.category.slug,
            media_id: path
          }
        }).catch(() => {})

        setTimeout(() => {
          this.throttle = false
        }, 800)
      }
    },
    addListeners() {
      window.addEventListener('keyup', this.handleArrowKeys)

      this.listenersTarget.addEventListener('touchstart', (event) => {
        this.touchstartX = event.changedTouches[0].screenX
      }, false)

      this.listenersTarget.addEventListener('touchend', (event) => {
        this.touchendX = event.changedTouches[0].screenX
        this.handleSwipe()
      }, false)
    },
    handleArrowKeys() {
      switch (event.keyCode) {
      case 37: this.pushRoute(this.pager.prev.slug)
        break
      case 39: this.pushRoute(this.pager.next.slug)
        break
      default:
      }
    },
    handleSwipe() {
      if ((this.touchendX - this.touchstartX) < -10) {
        this.pushRoute(this.pager.next.slug)
      }

      if ((this.touchendX - this.touchstartX) > 10) {
        this.pushRoute(this.pager.prev.slug)
      }
    }
  }
}
</script>
